import QRCode from 'react-qr-code'
import { useTranslation } from '../../hooks/useTranslation'

/** The review ask beside the shop's logo. The display is small and the phone
 *  is an arm's length away, so the QR takes as much of the canvas as the logo
 *  can spare, with the line under it (beside it in portrait). */
export default function ReviewCard({ googlePlaceId }: { googlePlaceId: string }) {
  const { t } = useTranslation()
  const url = `https://search.google.com/local/writereview?placeid=${googlePlaceId}`

  return (
    <div className="flex shrink-0 motion-safe:animate-stageIn flex-col items-center space-y-cfd-2 portrait:flex-row portrait:space-x-cfd-2 portrait:space-y-0 portrait:pr-cfd-3 rounded-[clamp(12px,2vh,22px)] border border-divider bg-white p-cfd-2 shadow-[0_8px_30px_rgba(39,42,48,0.08)]">
      <div className="h-[clamp(150px,min(48vh,30vw),560px)] w-[clamp(150px,min(48vh,30vw),560px)] portrait:h-[clamp(110px,min(20vh,34vw),360px)] portrait:w-[clamp(110px,min(20vh,34vw),360px)]">
        <QRCode value={url} title={t('share-your-experience')} className="h-full w-full" style={{ height: '100%', width: '100%' }} />
      </div>
      <div className="text-center portrait:max-w-[24vw] portrait:text-left">
        <div className="font-volte-semibold text-cfd-detail text-text-hi">{t('loved-your-visit')}</div>
        <div className="mt-0.5 text-cfd-label normal-case tracking-normal text-text-mid">{t('share-your-experience')}</div>
      </div>
    </div>
  )
}
